import type { Account } from '@shared/products-types';

import { useProductData } from './useProductData';

type HookReturnType = Omit<ReturnType<typeof useProductData<Account>>, 'updateAlias'>;

export const useCoreAccount: (id: string) => HookReturnType = (id: string) => {
    const { isPending, error, product, refetch } = useProductData(id);

    return {
        isPending,
        error,
        refetch,
        product,
    };
};
